import { render, staticRenderFns } from "./expanded.vue?vue&type=template&id=d276607a&scoped=true&lang=pug&"
import script from "./expanded.vue?vue&type=script&lang=js&"
export * from "./expanded.vue?vue&type=script&lang=js&"
import style0 from "./expanded.vue?vue&type=style&index=0&id=d276607a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d276607a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SiteJumbotronBreadcrumbs: require('/home/ubuntu/nuxt/bonkers/releases/20230927162708/components/site/jumbotron/breadcrumbs.vue').default,WidgetsImage: require('/home/ubuntu/nuxt/bonkers/releases/20230927162708/components/widgets/image.vue').default,WidgetsListItem: require('/home/ubuntu/nuxt/bonkers/releases/20230927162708/components/widgets/list-item.vue').default})
